import {
  APP_BTN_DANGER_CLASS,
  APP_BTN_DANGER_OUTLINE_CLASS,
  APP_BTN_OUTLINE_CLASS,
  APP_BTN_PRIMARY_CLASS,
  APP_INPUT_CLASS,
  APP_SELECT_TRIGGER_CLASS,
  APP_TEXTAREA_CLASS,
} from '../../../ui/controlStyles';

/**
 * Settings UI control styles — shared tokens for Einstellungen pages.
 *
 * App-wide size convention (all product UI): single-line inputs, select
 * triggers, and primary/outline/danger buttons use `h-9` / `rounded-md`
 * (see `.cursor/rules/ui-form-controls.mdc`). Prefer these constants under
 * `src/features/settings/**` instead of local `inputClass` / `btnPrimary`
 * duplicates.
 *
 * - Single-line inputs / select triggers / buttons → `h-9`
 * - Textareas → `SETTINGS_TEXTAREA_CLASS` (no fixed height)
 * - Selects: `triggerClassName={SETTINGS_SELECT_TRIGGER_CLASS}` on
 *   `AppSelect` / `AppSelectDropdown`. Never use native `<select>`.
 */

export const SETTINGS_CARD_SHELL =
  'md:rounded-lg md:border md:border-app-border bg-app-surface px-4 py-5 md:p-6 md:shadow-[0_1px_2px_rgba(15,23,42,0.06)]';

/** Feld- und Gruppenbeschriftung — gleiche Optik wie „Vorschau in Rechnungen“. */
export const SETTINGS_FIELD_LABEL = 'text-sm font-medium text-app-text';

/** Tabellen-Kopfzeilen — bewusst ohne Caps, damit lange Spaltentitel lesbar bleiben. */
export const SETTINGS_TABLE_HEADER = 'text-xs font-medium text-app-text-subtle';

export const SETTINGS_INPUT_CLASS = APP_INPUT_CLASS;

/** Multi-line fields only — never apply SETTINGS_INPUT_CLASS (fixed h-9) to textareas. */
export const SETTINGS_TEXTAREA_CLASS = APP_TEXTAREA_CLASS;

export const SETTINGS_SELECT_TRIGGER_CLASS = APP_SELECT_TRIGGER_CLASS;

export const SETTINGS_BTN_OUTLINE = APP_BTN_OUTLINE_CLASS;

export const SETTINGS_BTN_PRIMARY = APP_BTN_PRIMARY_CLASS;

export const SETTINGS_BTN_DANGER = APP_BTN_DANGER_CLASS;

export const SETTINGS_BTN_DANGER_OUTLINE = APP_BTN_DANGER_OUTLINE_CLASS;
